import {
  SET_RID,
  SET_ROOM,
  SET_ROOM_TYPE,
  CLEAR_ROOM
} from '@/store/mutation-types'
import { firebaseAction } from 'vuexfire'
import { numToKor } from '@/mixins/numToKor'
import Room from '@/models/room'
import l from '@/vendor/logger'
import { DB_TIMESTAMP } from '@/vendor/firebase'
import format from 'date-fns/format'
import ko from 'date-fns/locale/ko'
import { db } from '@/store'
import * as _ from 'ramda'

// type
// null
// CAST
// WATCH
// STUDIO
// ASSIST_BOARD

// room.status
// null
// READY
// LIVE
// QUIZ
// RESULT
// END

const state = {
  room: {},
  type: null
}

const getters = {
  formattedCreatedAt (state) {
    if (state.room.createdAt) {
      return format(
        state.room.createdAt, 'HH:mm:ss', { locale: ko }
      )
    }
  },
  formattedStartedAt (state) {
    if (state.room.startedAt) {
      return format(
        state.room.startedAt, 'HH:mm:ss', { locale: ko }
      )
    }
  },
  prizeKor (state) {
    if (state.room.prize) {
      return numToKor(state.room.prize)
    }
  },
  prizeConverted (state) {
    if (state.room.prize && state.room.prizeRatio) {
      return state.room.prize * state.room.prizeRatio
    }
  },
  prizeConvertedKor (state) {
    if (state.room.prize && state.room.prizeRatio) {
      return numToKor(state.room.prize * state.room.prizeRatio)
    }
  },
  quizIndexOffset (state) {
    if (state.room.status) {
      if (state.room.status === 'QUIZ' || state.room.status === 'COMPUTEWINNERS' || state.room.status === 'RESULT') {
        return 1
      } else {
        return 0
      }
    } else {
      return 0
    }
  },
  publishedQuizIndex (state) {
    if (state.room.publishedQuizIndex) {
      return state.room.publishedQuizIndex
    } else {
      return 0
    }
  },
  isCast (state) { return state.type === 'CAST' },
  isWatch (state) { return state.type === 'WATCH' },
  isStudio (state) { return state.type === 'STUDIO' },
  isAssistBoard (state) { return state.type === 'ASSIST_BOARD' },
  isChatConfig (state) { return state.type === 'CHAT_CONFIG' }
}

const mutations = {
  [SET_ROOM] (state, room) {
    let roomModel
    if (_.isEmpty(state.room)) {
      roomModel = Room()
    } else {
      roomModel = state.room
    }
    Object
      .keys(room)
      .filter(key => key in roomModel)
      .forEach(key => { roomModel[key] = room[key] })
    state.room = roomModel
  },
  [SET_ROOM_TYPE] (state, type) {
    state.type = type
  },
  [CLEAR_ROOM] (state, rootState) {
    state.room = {}
    state.type = null
  }
}

// cast call flow
// createCast -> rid
//   - SET_ROOM
// remon - onCreateChannel -> chid
//   - createRoom
// remon - onComplete
// removeRoom
// unbindRoom

// watch call flow
// remon - onComplate
//   - setWatcher
// unbindRoom

const actions = {
  clearRoom ({ commit }) {
    commit(CLEAR_ROOM)
    commit(SET_RID, null, { root: true })
  },

  bindRoom: firebaseAction(({ bindFirebaseRef, rootState }) => {
    bindFirebaseRef('room', db.ref(`room/${rootState.rid}`))
  }),

  unbindRoom: firebaseAction(({ unbindFirebaseRef, rootState, dispatch }) => {
    unbindFirebaseRef('room', db.ref(`room/${rootState.rid}`))
    db.ref(`room/${rootState.rid}`).off()
    dispatch('clearRoom')
  }),

  async createRoom ({ commit, dispatch, rootState, state }, chId) {
    l.d('room/createRoom', state.room)
    try {
      commit(SET_ROOM, { chId })
      await db.ref(`room/${rootState.rid}`).set({ ...state.room, status: 'INIT', createdAt: DB_TIMESTAMP })
      dispatch('bindRoom')
    } catch (err) {
      l.e('room/createRoom', err)
    }
  },

  updateRoom ({ state, rootState }, payload) {
    Object.keys(payload)
      .filter(k => Object.keys(state.room).includes(k))
      .forEach(async (k) => {
        l.d(`room/updateRoom`, k, payload[k])
        await db.ref(`room/${rootState.rid}`).update({
          [k]: payload[k]
        })
      })
  },

  async startLive ({ rootState }) {
    l.d(`room/startLive`)
    await db.ref(`room/${rootState.rid}/startedAt`).set(DB_TIMESTAMP)
    await db.ref(`room/${rootState.rid}`).update({ status: 'LIVE' })
  },

  async computeWinners ({ rootState }) {
    l.d(`room/computeWinners`)
    await db.ref(`room/${rootState.rid}/awardedAt`).set(DB_TIMESTAMP)
    await db.ref(`room/${rootState.rid}`).update({ status: 'COMPUTEWINNERS' })
  },

  async endLive ({ rootState }) {
    l.d(`room/endLive`)
    // await db.ref(`room/${rootState.rid}/endedAt`).set(DB_TIMESTAMP) //펑션스에서 히스토리에 직접 쓸게요
    await db.ref(`room/${rootState.rid}`).update({ status: 'END' })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
